<template>
  <div class="module-title" v-if="extras.titleBar.display == 1">
    <div
      class="title"
      v-if="extras.titleBar.title != 'hide'"
      :style="{
        background:
          extras.titleBar.colorOrBg == 'color' ? extras.titleBar.color : '',
        color:
          extras.titleBar.title == 'custom' ? extras.titleBar.fontColor : '',
        'font-size':
          extras.titleBar.title == 'custom'
            ? extras.titleBar.fontSize + 'px'
            : '',
        'font-style':
          extras.titleBar.title == 'custom'
            ? extras.titleBar.fontTilt == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.titleBar.title == 'custom'
            ? extras.titleBar.fontWeight == 'on'
              ? '900'
              : ''
            : '',
      }"
    >
      <span>{{ title }}</span>
      <img
        class="title-bg"
        v-if="extras.titleBar.colorOrBg == 'src'"
        :src="extras.titleBar.colorOrBg == 'src' ? extras.titleBar.src : ''"
        alt=""
      />
    </div>
    <div
      class="en"
      v-if="extras.titleBar.subTitle != 'hide'"
      :style="{
        color:
          extras.titleBar.subTitle == 'custom'
            ? extras.titleBar.fontColor2
            : '',
        'font-size':
          extras.titleBar.subTitle == 'custom'
            ? extras.titleBar.fontSize2 + 'px'
            : '',
        'font-style':
          extras.titleBar.subTitle == 'custom'
            ? extras.titleBar.fontTilt2 == 'on'
              ? 'italic'
              : 'normal'
            : '',
        'font-Weight':
          extras.titleBar.subTitle == 'custom'
            ? extras.titleBar.fontWeight2 == 'on'
              ? '900'
              : ''
            : '',
      }"
    >
      {{ en }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: String,
    en: String,
    extras: Object,
  },
  data: function () {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
